module.exports = __webpack_public_path__ + "static/media/FLIXB.3c6d56ed.svg";